import React from "react";
import { Route, Switch } from "react-router-dom";

import { OrganizationProvider } from "contextProviders/organization/OrganizationProvider";
import OrganizationIndexPage from "pages/_common/organization/OrganizationIndexPage";
import OrganizationCreateEditPage from "pages/_common/organization/OrganizationCreateEditPage";
import OrganizationDetailsRouter from "routes/OrganizationDetailsRouter";

const OrganizationsRouter = () => {
  return (
    <OrganizationProvider>
      <Switch>
        <Route exact path="/organizations" component={OrganizationIndexPage} />
        <Route path="/organizations/create" component={OrganizationCreateEditPage} />
        <Route path="/organizations/:organization_id" component={OrganizationDetailsRouter} />
      </Switch>
    </OrganizationProvider>
  );
};

export default OrganizationsRouter;
